import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { PaymentType } from '@app/shared/enums/payment-type.enum';

@Component({
  selector: 'app-payment-successful',
  templateUrl: './payment-successful.component.html',
  styleUrls: ['./payment-successful.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PaymentSuccessfulComponent implements OnInit {
  @Input() paymentType: PaymentType;
  hasDescription: boolean;

  ngOnInit(): void {
    this.hasDescription = this.paymentType === PaymentType.DownPaymentOnline;
  }
}
